import { render, staticRenderFns } from "./centralCharge.vue?vue&type=template&id=12e2e867&scoped=true&"
import script from "./centralCharge.vue?vue&type=script&lang=js&"
export * from "./centralCharge.vue?vue&type=script&lang=js&"
import style0 from "./centralCharge.vue?vue&type=style&index=0&id=12e2e867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e2e867",
  null
  
)

export default component.exports